import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { FILA_BLANCA, FILA_GRIS } from "config/general/Configuracion";
import PropTypes from "prop-types";
import React from "react";
import ChartistGraph from "react-chartist";
import { pieChart } from "variables/charts.jsx";
import TituloPagina2 from "conten/components/TituloPagina2";
import {
  successColor,
  whiteColor,
  blackColor,
} from "assets/jss/material-dashboard-pro-react.jsx";
import MinimalWazeMap from "components/MinimalWazeMap/MinimalWazeMap";
function pintarFila(key, color, colorTexto, campo1, campo2, campo3, campo4) {
  if (color == undefined) {
    color = FILA_BLANCA;
  }
  if (colorTexto == undefined) {
    colorTexto = FILA_BLANCA;
  }
  return (
    <>
      <GridItem
        key={"campo1" + key}
        xs={12}
        sm={12}
        md={12}
        style={{ backgroundColor: color, color: colorTexto }}
      >
        {campo1}
      </GridItem>
      <GridItem
        key={"campo2" + key}
        xs={12}
        sm={12}
        md={12}
        style={{ backgroundColor: color, color: colorTexto }}
      >
        {campo2}
      </GridItem>
      <GridItem
        key={"campo3" + key}
        xs={12}
        sm={12}
        md={12}
        style={{ backgroundColor: color, color: colorTexto }}
      >
        {campo3}
      </GridItem>
      <GridItem
        key={"campo4" + key}
        xs={12}
        sm={12}
        md={12}
        style={{ backgroundColor: color, color: colorTexto }}
      >
        {campo4}
      </GridItem>
    </>
  );
}

const openMapOptions = (lat, lon) => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const url = isIOS
    ? `http://maps.apple.com/?q=${lat},${lon}`
    : `geo:${lat},${lon}?q=${lat},${lon}`; // Android → abre chooser
  window.location.href = url;
};

function getDataForPieVehiculo(element, campo) {
  const CAPACIDAD_VEHICULO = "Capacidad" + campo;
  let ocupados = 0;
  let capacidad = 0;

  if (element) {
    ocupados = element[campo] || 0;
    capacidad = element[CAPACIDAD_VEHICULO] || 0;
  }

  // Corrección de datos nulos o mal ingresados
  if (capacidad === 0 && ocupados > 0) capacidad = ocupados;
  if (capacidad === 0 && ocupados < 1) capacidad = 1;

  const libres = capacidad - ocupados;

  // Armado dinámico de la gráfica
  const labels = [];
  const series = [];

  if (libres > 0) {
    labels.push("Libres");
    series.push(libres);
  }

  if (ocupados > 0) {
    labels.push("Ocupados");
    series.push(ocupados);
  }

  const data = {
    labels,
    series,
    titulo: (
      <>
        <div style={{ fontSize: '14px', fontWeight: '500', lineHeight: '20px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
          <h6 style={{ width: '74px', color: 'green' }}>
            {libres}
          </h6>
          <h6 style={{ width: '49px', color: 'red' }}>
            {ocupados}
          </h6>
        </div>
      </>
    )
  };

  return data;
}

function hacerTorta(data, info, tipoVehiculo) {

  if (info === undefined) {
    info = "";
  }
  return (
    <>
      <h6
        style={{
          marginBottom: "5px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          gap: "5px"
        }}
      >
        <span className="material-icons">
          {tipoVehiculo === "Carros" ? "directions_car" : "two_wheeler"}
        </span>
      </h6>
      <div
        style={{
          fontSize: '14px',
          fontWeight: '500',
          lineHeight: '20px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '10px'
        }}
      >{info}</div>
    </>
  );
}

function procesarListado(key, listado) {
  if (listado === undefined) return <></>;

  let resp = [];

  try {
    listado.forEach((element, index) => {
      const capacidadCarro = element.CapacidadCarro || 0;
      const capacidadMoto = element.CapacidadMoto || 0;

      const dataCarro = capacidadCarro > 0 ? getDataForPieVehiculo(element, "Carro") : null;
      const dataMoto = capacidadMoto > 0 ? getDataForPieVehiculo(element, "Moto") : null;

      const valorCarro = element.valor_hora_carro
        ? `$${Number(element.valor_hora_carro).toLocaleString()}`
        : "No definido";
      const valorMoto = element.valor_hora_moto
        ? `$${Number(element.valor_hora_moto).toLocaleString()}`
        : "No definido";

      const horarioSemana =
        element.entre_semana_inicia && element.entre_semana_termina
          ? `Lunes a Viernes: ${element.entre_semana_inicia} - ${element.entre_semana_termina}`
          : "Horario entre semana no definido";

      const horarioFinSemana =
        element.fin_semana_inicia && element.fin_semana_termina
          ? `Fines de semana: ${element.fin_semana_inicia} - ${element.fin_semana_termina}`
          : "Horario fin de semana no definido";

      resp.push(
        pintarFila(
          "fila" + index + "-" + key,
          index % 2 === 0 ? FILA_GRIS : FILA_BLANCA,
          blackColor,
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '7px'
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <span
                style={{
                  fontFamily: 'Google Sans,Roboto,sans-serif',
                  marginTop: '5px',
                  fontSize: '16px',
                  fontWeight: '400',
                  lineHeight: '20px'
                }}
              >
                {element.zona}
              </span>
              <h6 style={{ margin: '0px', fontWeight: '200', textTransform: 'none' }}>{horarioSemana}</h6>
              <h6 style={{ margin: '0px', fontWeight: '200', textTransform: 'none' }}>{horarioFinSemana}</h6>
              <div style={{
                marginTop: '5px',
                fontSize: '14px', fontWeight: '500',
                lineHeight: '20px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '15px'
              }}>
                <h6 style={{ fontSize: '11px', fontWeight: '200', lineHeight: '20px', margin: '0px', textTransform: 'none' }}>
                  Celdas
                </h6>
                <h6 style={{ fontSize: '11px', fontWeight: '200', lineHeight: '20px', margin: '0px', textTransform: 'none' }}>
                  Disponibles
                </h6>
                <h6 style={{ fontSize: '11px', fontWeight: '200', lineHeight: '20px', margin: '0px', textTransform: 'none' }}>
                  Ocupadas
                </h6>
                <h6 style={{ fontSize: '11px', fontWeight: '200', lineHeight: '20px', margin: '0px', textTransform: 'none' }}>
                  Valor
                </h6>
              </div>
              <div>
                {dataCarro ? (
                  <div style={{ display: 'flex', gap: '10px' }}>
                    {hacerTorta(dataCarro, dataCarro.titulo, "Carros")}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <h6 style={{ margin: '0px' }}>{valorCarro}</h6>
                    </div>

                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <span className="material-icons">
                      {"directions_car"}
                    </span>
                    <h6 style={{ color: "gray", fontStyle: "italic" }}>
                      No hay celdas para carros
                    </h6>
                  </div>
                )}
              </div>
              <div>
                {dataMoto ? (
                  <div style={{ display: 'flex', gap: '10px' }}>
                    {hacerTorta(dataMoto, dataMoto.titulo, "Motos")}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <h6 style={{ margin: '0px' }}>{valorMoto}</h6>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <span className="material-icons">
                      {"two_wheeler"}
                    </span>
                    <h6 style={{ color: "gray", fontStyle: "italic" }}>
                      No hay celdas para motos
                    </h6>
                  </div>
                )}
              </div>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '10px',
              width: '55px',
              height: '170px',
              justifyContent: 'center',
            }}
              onClick={() => openMapOptions(element.latitud, element.longitud)}
            >
              {element.distancia && (
                <span style={{ fontWeight: '600', fontSize: '14px' }}>{`${element.distancia.toFixed(1)} km`}</span>
              )}
              <div style={{ display: 'flex', width: '50px', height: '50px', alignContent: 'center', justifyContent: 'center', borderRadius: '50%', backgroundColor: '#c2c2c2ff', alignItems: 'center' }}>
                <span class="material-icons" style={{ color: '#162f4a', cursor: 'pointer' }} >directions</span>
              </div>
               {!element.distancia && (
                <span style={{ fontWeight: '400', fontSize: '14px' }}>{`Cómo llegar`}</span>
              )}
            </div>
          </div >,
          <div />
        )
      );
    });
  } catch (exp) {
    console.error("Error al procesar listado:", exp);
  }

  return resp;
}

function Ocupacion({ ...props }) {
  var {
    key,
    icono,
    titulo,
    color,
    contenido,
    userLocation,
    fechaControl } = props;
  if (contenido === undefined) {
    contenido = [];
  }
  return (
    <Card key={"Card" + key}>
      <CardHeader color={color} icon>
        <CardIcon color={color}>{icono}{fechaControl}</CardIcon>
        <TituloPagina2
          color={color}
          texto={titulo}
        />
      </CardHeader>
      <CardBody>
        <center>
          <GridContainer
            style={Object.assign({ gap: "0px" },
            )}>
            {pintarFila(
              "titulo" + key,
              successColor[0],
              whiteColor,
              <h5 style={{ fontSize: '20px', fontWeight: '500', lineHeight: '26px' }}>Zonas</h5>
            )}
            <MinimalWazeMap
              zonas={contenido.map((element) => ({
                nombre: element.zona, // o element.nombre si tu objeto tiene esa propiedad
                lat: element.latitud,
                lon: element.longitud,
              }))}
              userLocation={userLocation}
              hasLocation={userLocation !== undefined}
            />
            {procesarListado(key, contenido)}
          </GridContainer>
        </center>
      </CardBody>
    </Card>
  );
}

Ocupacion.propTypes = {
  contenido: PropTypes.array,
  classCardIconTitle: PropTypes.string,
  key: PropTypes.object.isRequired,
  icono: PropTypes.node,
  titulo: PropTypes.string,
  color: PropTypes.string,
  classes: PropTypes.object.isRequired,
  fechaControl: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "warning",
    "danger",
    "success",
    "info",
    "rose",
    "gray",
  ]),
};

export default withStyles()(Ocupacion);
